import { render } from "./umbrella.vue?vue&type=template&id=ea8694da"
import script from "./umbrella.vue?vue&type=script&lang=js"
export * from "./umbrella.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__